import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKnowledgeDocuments } from '@/hooks/useKnowledge';
import { DocumentCard } from '@/components/knowledge/DocumentCard';
import { SearchFilters } from '@/components/knowledge/SearchFilters';
import { Button } from '@/components/ui/button';
import { Settings } from 'lucide-react';

export function KnowledgeListPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [categorySlug, setCategorySlug] = useState<string>('all');
  const [status, setStatus] = useState<string>('all');

  const query = {
    search: search || undefined,
    categorySlug: categorySlug === 'all' ? undefined : categorySlug,
    status: status === 'all' ? undefined : (status as 'draft' | 'published' | 'deprecated'),
  };

  const { data: documents, isLoading } = useKnowledgeDocuments(query);

  // Extract unique categories
  const categories = Array.from(
    new Set(documents?.map((d) => d.categorySlug) || [])
  );

  return (
    <div className="container mx-auto py-8 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Base de Conhecimento</h1>
        <Button onClick={() => navigate('/settings/knowledge-extraction')}>
          <Settings className="h-4 w-4 mr-2" />
          Configurações
        </Button>
      </div>

      <SearchFilters
        search={search}
        onSearchChange={setSearch}
        categorySlug={categorySlug}
        onCategoryChange={setCategorySlug}
        status={status}
        onStatusChange={setStatus}
        categories={categories}
      />

      {isLoading ? (
        <div className="text-center py-12 text-muted-foreground">
          Carregando documentos...
        </div>
      ) : documents && documents.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {documents.map((doc) => (
            <DocumentCard
              key={doc.id}
              document={doc}
              onClick={() => navigate(`/knowledge/${doc.id}`)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-muted-foreground">
          Nenhum documento encontrado
        </div>
      )}
    </div>
  );
}
